module.exports = __webpack_public_path__ + "img/GoblinFemale_Light.d74063cd.gif";